function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12,
  r: 12,
  fill: "#EB7B31"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.0962,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.52131,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.8931,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.3182,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.26609 12.96C6.60552 12.2996 7.10303 11.6996 7.7302 11.1942C8.35738 10.6887 9.10195 10.2878 9.9214 10.0143C10.7408 9.74075 11.6191 9.59996 12.5061 9.59996C13.3931 9.59996 14.2713 9.74075 15.0908 10.0143C15.9102 10.2878 16.6548 10.6887 17.282 11.1942C17.9092 11.6996 18.4067 12.2996 18.7461 12.96",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8087 5.66036C16.8087 5.66036 18.156 6.2712 18.5668 7.29446C18.7456 7.73963 18.4658 8.2708 17.9414 8.48145C17.4164 8.69198 16.8469 8.50181 16.6681 8.05664C16.4692 7.56116 16.8087 5.66036 16.8087 5.66036Z",
  fill: "black"
});

var Svg7SevenSevere = function Svg7SevenSevere(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg7SevenSevere, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/7_seven_Severe.96d6307f.svg";
export { ForwardRef as ReactComponent };